module.exports = __webpack_public_path__ + "img/red_061.dee308e0.png";